// extracted by mini-css-extract-plugin
module.exports = {"atm_c8_1j6vyhq":"atm_c8_1j6vyhq"};